// Version : 0.0.1
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last Add : 'UNSED IMPORTS AND VARIABLES REMOVED'
// Modified Date : 04-08-2025
import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** ***************** FETCH OFFICER LIST CENTERS START *********************** */
export const fetchOfficerListCenters = (listData: any) => {
	const data = {
		CenterListBasedForOfficerToken: listData,
	};
	const url = `${API_URL}getCenterListForOfficer`;
	return makeApiCall(url, data);
};
/** ***************** FETCH OFFICER LIST CENTERS END *********************** */

/** ***************** FETCH OFFICER LIST ARREAR CENTERS START *********************** */
export const fetchOfficerListArrearCenters = (listData: any) => {
	const data = {
		ArrearCenterListBasedForOfficerToken: listData,
	};
	const url = `${API_URL}getArrearCenterListForOfficer`;
	return makeApiCall(url, data);
};
/** ***************** FETCH OFFICER LIST ARREAR CENTERS END *********************** */

/** ***************** FETCH BRANCH COLLECTION USERS LIST START *********************** */
export const fetchBranchCollectionUsersList = (listData: any) => {
	const data = {
		BranchCollectionUsersToken: listData,
	};
	const url = `${API_URL}getBranchCollectionUsers`;
	return makeApiCall(url, data);
};
/** ***************** FETCH BRANCH COLLECTION USERS LIST END *********************** */

/** ***************** FETCH CENTER LIST OFFICER COLLECTIONS START *********************** */
export const fetchCenterListOfficerCollections = (listData: any) => {
	const data = {
		centerListOfficerCollectionsToken: listData,
	};
	const url = `${API_URL}getCenterListOfficerCollection`;
	return makeApiCall(url, data);
};
/** ***************** FETCH CENTER LIST OFFICER COLLECTIONS END *********************** */

/** ***************** FETCH BRANCH TODAY COLLECTION DETAILS START *********************** */
export const fetchBranchTodayCollectionDetails = (listData: any) => {
	const data = {
		FetchBranchTodayCollectionDetailsToken: listData,
	};
	const url = `${API_URL}getBranchTodayCollectionMembersForApprove`;
	return makeApiCall(url, data);
};
/** ***************** FETCH BRANCH TODAY COLLECTION DETAILS END *********************** */

/** ***************** FETCH BRANCH TODAY DEMAND MOVE TO ARREAR LIST START *********************** */
export const fetchBranchTodayDemandMoveToArrearList = (listData: any) => {
	const data = {
		FetchBranchTodayDemandMoveToArrearListToken: listData,
	};
	const url = `${API_URL}getBranchTodayDemandMoveToArrear`;
	return makeApiCall(url, data);
};
/** ***************** FETCH BRANCH TODAY DEMAND MOVE TO ARREAR LIST END *********************** */

/** ***************** FETCH BRANCH CLOSED LOAN LIST START *********************** */
export const fetchBranchClosedLoanList = (listData: any) => {
	const data = {
		CloseLoanListFetchToken: listData,
	};
	const url = `${API_URL}fetchCloseLoanList`;
	return makeApiCall(url, data);
};
/** ***************** FETCH BRANCH CLOSED LOAN LIST END *********************** */

/** ***************** FETCH CENTER COLLECTION DENOMINATION DETAILS START *********************** */
export const fetchCenterCollectionDenominationDetails = (listData: any) => {
	const data = {
		FetchCenterCollectionDenominationToken: listData,
	};
	const url = `${API_URL}getCenterCollectionDenomination`;
	return makeApiCall(url, data);
};
/** ***************** FETCH CENTER COLLECTION DENOMINATION DETAILS END *********************** */

/** ***************** FETCH ATTENDANCE OFFICER COLLECTION DETAILS START *********************** */
export const fetchAttendanceOfficerCollectionDetails = (listData: any) => {
	const data = {
		FetchAttendanceBasedOfficerCollectionToken: listData,
	};
	const url = `${API_URL}attendanceBasedOfficerCollection`;
	return makeApiCall(url, data);
};
/** ***************** FETCH ATTENDANCE OFFICER COLLECTION DETAILS END *********************** */

/** ***************** FETCH BRANCH COLLECTION FUNDER ALLOCATE EOD DETAILS START *********************** */
export const fetchBranchCollectionFunderAllocateEODDetails = (listData: any) => {
	const data = {
		BranchCollectionsAllocateForEodToken: listData,
	};
	const url = `${API_URL}getBranchCollectionsFunderAllocateForEod`;
	return makeApiCall(url, data);
};
/** ***************** FETCH BRANCH COLLECTION FUNDER ALLOCATE EOD DETAILS END *********************** */

/** ***************** FETCH BRANCH TODAY COLLECTIONS YET TO APPROVE START *********************** */
export const fetchBranchTodayCollectionsYetToApprove = (listData: any) => {
	const data = {
		BranchTodayCollectionMembersYetToApproveToken: listData,
	};
	const url = `${API_URL}getBranchTodayCollectionMembersForYetToApprove`;
	return makeApiCall(url, data);
};
/** ***************** FETCH BRANCH TODAY COLLECTIONS YET TO APPROVE END *********************** */

/** ***************** UPDATE LOAN PAID PER MEMBER COLLECTION APPROVE START *********************** */
export const updateLoanPaidPerMemberCollectionApprove = (listData: any) => {
	const data = {
		LoanPaidPerMemberCollectionApproveDataToken: listData,
	};
	const url = `${API_URL}updateLoanPaidPerMemberCollectionApprove`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE LOAN PAID PER MEMBER COLLECTION APPROVE END *********************** */

/** ***************** UPDATE LOAN PAID ALL COLLECTION APPROVE START *********************** */
export const updateLoanPaidAllCollectionApprove = (listData: any) => {
	const data = {
		UpdateLoanPaidCollectionApproveToken: listData,
	};
	const url = `${API_URL}updateLoanPaidCollectionApprove`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE LOAN PAID ALL COLLECTION APPROVE END *********************** */

/** ***************** SECURITY PASSWORD VERIFY START *********************** */
export const securityPasswordVerify = (listData: any) => {
	const data = {
		UserPasscodeVerificationToken: listData,
	};
	const url = `${API_URL}getUserPasscodeVerification`;
	return makeApiCall(url, data);
};
/** ***************** SECURITY PASSWORD VERIFY END *********************** */

/** ***************** REVERT ALLOCATE EOD START *********************** */
export const revertAllocateEOD = (listData: any) => {
	const data = {
		RevertBranchAllocateForEndOfDayToken: listData,
	};
	const url = `${API_URL}revertBranchAllocateForEndOfDay`;
	return makeApiCall(url, data);
};
/** ***************** REVERT ALLOCATE EOD END *********************** */

/** ***************** COMMON COLLECTION UPDATE START *********************** */
export const commonCollectionUpdate = (listData: any) => {
	const data = {
		UpdateCommonLoanPaidDetailsToken: listData,
	};
	const url = `${API_URL}updateCommonLoanPaid`;
	return makeApiCall(url, data);
};
/** ***************** COMMON COLLECTION UPDATE END *********************** */

/** ***************** CHECK BRANCH EOD EXIST START *********************** */
export const checkBranchEODExist = (listData: any) => {
	const data = {
		checkBranchEODExistDataToken: listData,
	};
	const url = `${API_URL}checkBranchEODExist`;
	return makeApiCall(url, data);
};
/** ***************** CHECK BRANCH EOD EXIST END *********************** */

/** ***************** CHECK BRANCH EOD EXIST FOR DATE START *********************** */
export const checkBranchEODExistForDate = (listData: any) => {
	const data = {
		CheckEODDoneForBranchDateToken: listData,
	};
	const url = `${API_URL}checkEODDoneForBranchDate`;
	return makeApiCall(url, data);
};
/** ***************** CHECK BRANCH EOD EXIST FOR DATE END *********************** */

/** ***************** UPDATE LOAN PAID MOVE TO ARREAR START *********************** */
export const updateLoanPaidMoveToArrear = (listData: any) => {
	const data = {
		loanAllMemberMoveToArrearToken: listData,
	};
	const url = `${API_URL}setAllMemberMoveToArrear`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE LOAN PAID MOVE TO ARREAR END *********************** */

/** ***************** UPDATE OVERALL ACCRUED INTEREST ALLOCATE FOR EOD CALL START *********************** */
export const updateOverallAccruedInterestAllocateForEODCall = (listData: any) => {
	const data = {
		UpdateAccruedInterestAllocateForEODToken: listData,
	};
	const url = `${API_URL}updateAccruedInterestAllocateForEodFinance`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE OVERALL ACCRUED INTEREST ALLOCATE FOR EOD CALL END *********************** */

/** ***************** UPDATE OVERALL ALLOCATE FOR EOD CALL START *********************** */
export const updateOverallAllocateForEODCall = (listData: any) => {
	const data = {
		BranchCollectionsAllocateForEODFinanceToken: listData,
	};
	const url = `${API_URL}getBranchCollectionsAllocateForEodFinance`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE OVERALL ALLOCATE FOR EOD CALL END *********************** */

/** ***************** FETCH GOLD LOAN COLLECTION APPROVE LIST START *********************** */
export const fetchGoldLoanCollectionApproveList = (listData: any) => {
	const data = {
		GoldCollectionMembersForApproveToken: listData,
	};
	const url = `${API_URL}getBranchGoldCollectionMembersForApprove`;
	return makeApiCall(url, data);
};
/** ***************** FETCH GOLD LOAN COLLECTION APPROVE LIST END *********************** */

/** ***************** FETCH SAVINGS COLLECTION APPROVE DETAILS START *********************** */
export const fetchSavingsCollectionApproveDetails = (listData: any) => {
	const data = {
		SavingsCollectionMembersForApproveToken: listData,
	};
	const url = `${API_URL}getSavingsCollectionApprove`;
	return makeApiCall(url, data);
};
/** ***************** FETCH SAVINGS COLLECTION APPROVE DETAILS END *********************** */

/** ***************** UPDATE SAVINGS ALLOCATE FOR EOD START *********************** */
export const savingsAllocateForApproveUpdate = (listData: any) => {
	const data = {
		EODApproveForSavingsToken: listData,
	};
	const url = `${API_URL}updateSavingsAllocateForEod`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE SAVINGS ALLOCATE FOR EOD END *********************** */

/** ***************** FETCH SAVINGS DENOMINATION DETAILS START *********************** */
export const fetchSavingsDenominationDetails = (listData: any) => {
	const data = {
		GetSavingsDenominationToken: listData,
	};
	const url = `${API_URL}getSavingsDenomination`;
	return makeApiCall(url, data);
};
/** ***************** FETCH SAVINGS DENOMINATION DETAILS END *********************** */

/** ***************** UPDATE GOLD LOAN COLLECTION APPROVE START *********************** */
export const updateGoldLoanCollectionApproveDetails = (listData: any) => {
	const data = {
		GoldLoanCollectionApproveToken: listData,
	};
	const url = `${API_URL}updateGoldLoanCollectionApprove`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE GOLD LOAN COLLECTION APPROVE END *********************** */

/** ***************** UPDATE SAVINGS COLLECTION APPROVE START *********************** */
export const updateSavingsCollectionApproveDetails = (listData: any) => {
	const data = {
		savingsMemberCollectionApproveToken: listData,
	};
	const url = `${API_URL}SavingsMemberCollectionApproveToken`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE SAVINGS COLLECTION APPROVE END *********************** */

/** ***************** SUBMIT APPROVE STAFF TRAVEL DETAILS START *********************** */
export const submitApproveStaffTravelDetails = (listData: any) => {
	const data = {
		StaffTravelApproveToken: listData,
	};
	const url = `${API_URL}approveStaffTravelDetails`;
	return makeApiCall(url, data);
};
/** ***************** SUBMIT APPROVE STAFF TRAVEL DETAILS END *********************** */
